import * as React from 'react';
import { Heading5 } from '@flightstats/airframe-react';

type FormResponseErrorProps = {
  message: string;
};

export const FormResponseError: React.FC<FormResponseErrorProps> = ({ message }) => (
    <Heading5
      textAlign="center"
      color="feedback.error"
      singleLine={false}
      style={{
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
      }}
    >
      {message}
    </Heading5>
);